module.exports = __webpack_public_path__ + "static/media/logo_interattivo_free.edf61627.svg";